import settings from "./settings";
export default (() => {
    const baseUrl = settings.api.url;
    // Module-specific base URLs — follow the env-resolved baseUrl so prod always uses prodapi
    const sbomBaseUrl = baseUrl;
    const aigBaseUrl = baseUrl;
    const tcBaseUrl = baseUrl;
    const opsBaseUrl = sbomBaseUrl;
    return {
        //Auth API Endpoints 
        SEND_OTP: baseUrl + "auth/send-otp/",
        SIGN_UP: baseUrl + "auth/signup/",
        SIGN_IN: baseUrl + 'auth/login/',
        FORGOT_PASSWORD: baseUrl + 'auth/forgot-password/',
        VERIFY_OTP: baseUrl + 'auth/verify-otp/',
        RESET_PASSWORD: baseUrl + 'auth/reset-password/',
        USER_PROFILE_UPDATE: 'auth/profile/update/',
        USER_PLAN_INFO: baseUrl + 'auth/profile/plan/',
        USER_PROFILE: baseUrl + 'auth/profile/',
        AUTH_METADATA: baseUrl + 'auth/metadata/',

        // Dashboard API Endpoints
        SCANNER_DOMAIN_RESULTS: baseUrl + 'scanner/org-aggregate/latest-summary/',

        SCANNER_ISSUE_DETAILS: ({ finding_type, category, limit, offset, count_order, severity_order, severity }) => {
            let url = `${baseUrl}scanner/org-aggregate/latest-issues/`;
            const params = new URLSearchParams();
            if (finding_type) {
                params.append('finding_type', finding_type);
            }

            if (category) {
                params.append('category', category);
            }
            if (limit) {
                params.append('limit', limit);
            }

            if (offset) {
                params.append('offset', offset);
            }
            if (count_order) {
                params.append('count_order', count_order)
            }
            if (severity_order) {
                params.append('severity_order', severity_order)
            }
            if (severity) {
                params.append('severity', severity)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }


            return url;
        },

        DOWNLOAD_EVIDENCE_CSV: baseUrl + 'scanner/org-aggregate/download-evidence-csv/',

        FINDINGS_SOLUTION_DETAILS: ({ category, finding, }) => {
            let url = `${baseUrl}scanner/org-aggregate/solution-detail/`;
            const params = new URLSearchParams();

            if (category) {
                params.append('category', category);
            }

            if (finding) {
                params.append('finding', finding)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        CATEGORY_FINDINGS: baseUrl + 'scanner/org-aggregate/categories-findings/',

        LOGOUT: baseUrl + 'auth/logout/',
        REFRESH_TOKEN: baseUrl + 'auth/refresh/',
        ORGANIZATION_DOMAINS: baseUrl + 'scanner/domains/organization-domains/',
        TOGGLE_BLACKLIST: baseUrl + 'scanner/domains/toggle-blacklist/',
        TOGGLE_POPUP: baseUrl + 'scanner/solutions/toggle-popup/',
        DOMAIN_ADDITION_REQUEST: baseUrl + 'scanner/domain-addition-request/',
        ASSEST_MANAGEMENT: baseUrl + 'scanner/assest-management/fetch-assets/',
        CHANGE_PASSWORD: baseUrl + 'auth/change-password/',

        // AI CHATBOT
        SEND_AI_QUERY: baseUrl + 'ai/chatbot/',
        CHATBOT_INITIALIZE: baseUrl + 'ai/chatbot/initialize/',
        DELETE_SESSION: baseUrl + 'ai/chatbot/session/',

        // Add on service
        ADD_ON_SERVICE: baseUrl + 'scanner/user-addons/',

        // RISK REGISTRY Endpoint

        ADD_NEW_RISK_REGISTRY: baseUrl + 'scanner/risk-registry/',
        TOTAL_RISK_CREATED: ({ start_date, end_date, limit, offset, ordering, }) => {
            let url = `${baseUrl}scanner/risk-registry/stats/`;
            const params = new URLSearchParams();

            if (start_date) {
                params.append('start_date', start_date);
            }
            if (end_date) {
                params.append('end_date', end_date)
            }
            if (limit) {
                params.append('limit', limit);
            }
            if (offset) {
                params.append('offset', offset);
            }
            if (ordering) {
                params.append('ordering', ordering)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        RISK_BY_STATS: ({ state, limit, offset, ordering, }) => {
            let url = `${baseUrl}scanner/risk-registry/by-state/`;
            const params = new URLSearchParams();

            if (state) {
                params.append('state', state);
            }
            if (limit) {
                params.append('limit', limit);
            }
            if (offset) {
                params.append('offset', offset);
            }
            if (ordering) {
                params.append('ordering', ordering)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        RISK_BY_SEVERITY: ({ severity, limit, offset, ordering, }) => {
            let url = `${baseUrl}scanner/risk-registry/by-severity/`;
            const params = new URLSearchParams();

            if (severity) {
                params.append('severity', severity);
            }
            if (limit) {
                params.append('limit', limit);
            }
            if (offset) {
                params.append('offset', offset);
            }
            if (ordering) {
                params.append('ordering', ordering)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        DOWNLOAD_RISK_REGISTRY: ({ end_date, start_date, }) => {
            let url = `${baseUrl}scanner/risk-registry/download/`;
            const params = new URLSearchParams();
            if (end_date) {
                params.append('end_date', end_date);
            }
            if (start_date) {
                params.append('start_date', start_date);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        LIST_ALL_RISK: baseUrl + 'scanner/risk-registry/',
        DELETE_RISK_REGISTRY: ({ id }) => `${baseUrl}scanner/risk-registry/${id}/`,

        GET_BY_ID_RISK_REGISTRY: ({ id }) => {

            let url = `${baseUrl}scanner/risk-registry/${id}`;
            return url;
        },

        EDIT_BY_ID_RISK_REGISTRY: (id) => `${baseUrl}scanner/risk-registry/${id}/`,
        BULK_UPLOAD_RISK_REGISTRY: baseUrl + 'scanner/risk-registry/bulk-upload/',
        DOWNLOAD_RISK_REGISTRY_TEMPLATE: baseUrl + 'scanner/risk-registry/download-excel-template/',
        SEND_RISK_NOTIFICATION: (id) => `${baseUrl}scanner/risk-registry/${id}/send-notification/`,

        // Third party endpont

        ADD_NEW_VENDOR: baseUrl + 'third-party/organization/third-party/add-domain/',
        META_DATA: baseUrl + 'auth/metadata/',
        GET_ALL_THIRDPARTY_DOMAINS: baseUrl + 'third-party/organization/third-party/domains/',

        DELETE_BY_ID_THIRDPARTY_DOMAIN: ({ id }) => {
            let url = `${baseUrl}third-party/organization/third-party/remove-domain/${id}`;
            return url;
        },

        GET_BY_ID_THIRD_PARTY: ({ id }) => {
            let url = `${baseUrl}third-party/organization/third-party/domains/${id}`;
            return url;
        },

        EDIT_BY_ID_THIRD_PARTY: (id) => `${baseUrl}third-party/organization/third-party/update-domain/${id}/`,

        VENDORS_BY_BUSINESS_IMPACT_GRAPH: ({ analysis_date }) => {
            let url = `${baseUrl}third-party/organization/third-party/risk-heatmap`;
            const params = new URLSearchParams();
            if (analysis_date) {
                params.append('analysis_date', analysis_date)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        VENDORS_POSITIVE_NEGATIVE_TREND: ({ analysis_date, limit_positive, limit_negative, days_back }) => {
            let url = `${baseUrl}third-party/organization/third-party/vendor-trend`;
            const params = new URLSearchParams();
            if (analysis_date) {
                params.append('analysis_date', analysis_date)
            }
            if (limit_positive) {
                params.append('limit_positive', limit_positive);
            }
            if (limit_negative) {
                params.append('limit_negative', limit_negative);
            }
            if (days_back) {
                params.append('days_back', days_back);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        DOWNLOAD_THIRD_PARTY: ({ start_date, }) => {
            let url = `${baseUrl}third-party/organization/third-party/download-domains/`;
            const params = new URLSearchParams();

            if (start_date) {
                params.append('start_date', start_date);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        THIRD_PARTY_MONITORED_VENDORS: ({ search, ordering, analysis_date }) => {
            let url = `${baseUrl}third-party/organization/third-party/relations`;
            const params = new URLSearchParams();
            if (analysis_date) {
                params.append('analysis_date', analysis_date);
            }
            if (search) {
                params.append('search', search);
            }
            if (ordering) {
                params.append('ordering', ordering);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        VENDORS_WITH_INCIDENTS: ({ analysis_date }) => {

            let url = `${baseUrl}third-party/organization/third-party/degraded/`;
            const params = new URLSearchParams();
            if (analysis_date) {
                params.append('analysis_date', analysis_date)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        VENDORS_WITH_CRITICAL_BUSINESS_IMPACT: ({ analysis_date }) => {
            let url = `${baseUrl}third-party/organization/third-party/dwi-increased/`;
            const params = new URLSearchParams();
            if (analysis_date) {
                params.append('analysis_date', analysis_date)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        SHOW_DETAIL_VENDORS_DATA: ({ target_organization_id, sort_by }) => {
            let url = `${baseUrl}third-party/organization/third-party/relation-aggregate`;
            const params = new URLSearchParams();
            if (target_organization_id) {
                params.append('target_organization_id', target_organization_id);
            }
            if (sort_by) {
                params.append('sort_by', sort_by)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        SEND_INVITATION_TO_VENDOR: baseUrl + 'third-party/organization/third-party/send-invitation/',
        BULK_UPLOAD_VENDORS: baseUrl + 'third-party/organization/third-party/bulk-upload-vendors/',
        DOWNLOAD_VENDOR_TEMPLATE: baseUrl + 'third-party/organization/third-party/download-vendor-template/',
        DOWNLOAD_CXO_REPORT: (vendor_id) => `${baseUrl}third-party/tprm/vendor/${vendor_id}/cxo-report/`,


        // Vulnerability Management Endpoints

        GET_AGENTS_VM_DATA: baseUrl + 'scanner/fe-vm/agents/',
        GET_VULNERABILITIES_DATA: baseUrl + 'scanner/fe-vm/vulnerability-counts/',

        SHOW_DETAIL_VULNERABILITIES_DATA: ({ exploitability, severity, flat, search, page_size }) => {
            let url = `${baseUrl}scanner/fe-vm/vulnerabilities/`;
            const params = new URLSearchParams();
            if (exploitability) {
                params.append('exploitability', exploitability);
            }
            if (severity) {
                params.append('severity', severity)
            }
            if (search) {
                params.append('search', search)
            }
            if (flat) {
                params.append('flat', flat)
            }
            if (page_size) {
                params.append("page_size", page_size)
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        TRACK_VM_GRAPH_DATA: ({ months_back }) => {
            let url = `${baseUrl}scanner/fe-vm/vulnerability-tracks/`;
            const params = new URLSearchParams();
            if (months_back) {
                params.append('months_back', months_back);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },

        DOWNLOAD_VM_EXCEL_FILE: baseUrl + "scanner/fe-vm/download-excel/",
        USER_DATA: baseUrl + 'website/user-region/',
        REQUEST_EVIDENCE_EXCEPTION: baseUrl + 'scanner/evidence-exceptions/request-exception/',
        BULK_REQUEST_EXCEPTION: baseUrl + 'scanner/evidence-exceptions/bulk-request-exception/',
        GET_BANK_LIST: baseUrl + 'bank-audit/banks/',
        ADD_BANK: baseUrl + 'bank-audit/banks/',
        INVITE_BANKS: baseUrl + 'bank-audit/banks/invite/',
        BANK_SIGNUP: baseUrl + 'bank-audit/bank-signup/',

        // Complaince Ready

        ASSIGN_ORGANIZATION_COMPLIANCE_FORM: baseUrl + 'compliance/organization-compliance/',
        DOMAIN_SELECTION_LIST: (id) => `${baseUrl}compliance/domains/?framework_id=${id}`,
        CHECK_COMPLIANCE_ORGANIZATION_FRAMEWORK: (id) => `${baseUrl}compliance/organization-compliance/?framework_id=${id}`,
        ASSIGN_ORGANIZATION_DOMAIN_OWNER: baseUrl + 'compliance/organization-domains/',
        USER_ASSIGN_DOMAINS_QUESTIONS_LIST: baseUrl + 'compliance/user-assigned-domains/',
        CHECK_WITH_NOVA: baseUrl + 'compliance/ai-evaluations/',
        UPLOAD_DOUCMENT_TO_CHECK_WITH_NOVA: baseUrl + 'compliance/user-documents/',
        SUBMIT_FRAMEWORK_QUESTION_ANSWER: baseUrl + 'compliance/control-question-answers/',
        DOMAIN_COMPLIANCE_REPORT: baseUrl + 'compliance/domain-compliance-report/',
        OVERALL_COMPLIANCE_REPORT: baseUrl + 'compliance/overall-compliance-report/',
        COMPLIANCE_FRAMEWORKS: baseUrl + 'compliance/frameworks/',
        DOMAIN_CONTROLS: ({ domain_id, show_unmapped, framework_id }) => {
            let url = `${baseUrl}compliance/domain-controls/`;
            const params = new URLSearchParams();
            if (domain_id !== undefined) params.append('domain_id', domain_id);
            if (show_unmapped !== undefined) params.append('show_unmapped', show_unmapped);
            if (framework_id !== undefined) params.append('framework_id', framework_id);
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        DOMAIN_CONTROLS_QUESTIONS: ({ domain_id }) => {
            let url = `${baseUrl}compliance/domain-controls-questions/`;
            const params = new URLSearchParams();
            if (domain_id !== undefined) params.append('domain_id', domain_id);
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        OWNER_BASE_COMPLIANCE_REPORT: baseUrl + 'compliance/owner-based-compliance-report/',
        SHARING_QUESTION: baseUrl + 'compliance/question-sharing/',
        DELETE_QUESTION_SHARING: baseUrl + 'compliance/question-sharing/',
        DOWNLOAD_SCANNER_REPORT: baseUrl + 'scanner/generate-pdf',
        GENERATE_EXECUTIVE_PDF: (id) => `${baseUrl}scanner/generate-executive-report-link/${id}/`,
        ORG_COMPLIANT_REPORT: baseUrl + 'compliance/organization-compliance-report/',
        FRAMEWORK_COMPLIANCE_MAPPING: baseUrl + 'compliance/framework-compliance-mapping',
        FRAMEWORK_COMPLIANCE: baseUrl + 'compliance/frameworks/',
        COMPLIANCE_DOMAINS: baseUrl + 'compliance/domains/',
        WEBSITE_WHATS_NEW: baseUrl + 'website/whats-new',
        SCANNER_NOTIFICATIONS: baseUrl + 'scanner/notifications',
        THIRDPARTY_EXTERNAL_EXPOSURE_QUESTIONS: baseUrl + 'third-party/tprm/organization/questions/',
        THIRDPARTY_QUESTIONS_TEMPLATE: baseUrl + 'third-party/tprm/organization/questions/template/',
        THIRDPARTY_QUESTIONS_BULK_UPLOAD: baseUrl + 'third-party/tprm/organization/questions/bulk-upload/',
        TPRM_ASSESSMENTS: baseUrl + 'third-party/tprm/assessments/',
        CREATE_TPRM_ASSESSMENT: baseUrl + 'third-party/tprm/assessments/',
        TPRM_ASSESSMENT_CATEGORIES: baseUrl + 'third-party/tprm/assessments/categories/',
        VENDOR_ASSESSMENT_VIEW: (access_token) => `${baseUrl}third-party/tprm/vendor/assessment/${access_token}/`,
        VENDOR_ASSESSMENT_SUBMIT: (access_token) => `${baseUrl}third-party/tprm/vendor/submit/${access_token}/`,
        ASSESSMENT_RESPONSES: (assessment_id, is_reviewed) => {
            let url = `${baseUrl}third-party/tprm/assessments/${assessment_id}/responses/`;
            if (is_reviewed !== undefined) {
                url += `?is_reviewed=${is_reviewed}`;
            }
            return url;
        },
        ASSESSMENT_DETAILS: (assessment_id) => `${baseUrl}third-party/tprm/assessments/${assessment_id}/`,
        REVIEW_RESPONSE: (response_id) => `${baseUrl}third-party/tprm/responses/${response_id}/review/`,
        UPDATE_ASSESSMENT_REVIEW_STATUS: (assessment_id) => `${baseUrl}third-party/tprm/assessments/${assessment_id}/review-status/`,
        UPLOAD_ASSESSMENT_DOCUMENTS: baseUrl + 'third-party/tprm/assessments/upload-documents/',
        VENDOR_DOCUMENT_UPLOAD: (access_token) => `${baseUrl}third-party/tprm/vendor/upload-documents/${access_token}/`,
        VENDOR_RESPONSE_DOCUMENT_UPLOAD: (access_token, response_id) => `${baseUrl}third-party/tprm/vendor/response/${access_token}/${response_id}/documents/`,
        VENDOR_RESPONSE_DOCUMENT_DELETE: (access_token, response_id) => `${baseUrl}third-party/tprm/vendor/response/${access_token}/${response_id}/documents/`,
        VENDOR_QUESTION_SUGGESTIONS: (access_token) => `${baseUrl}third-party/tprm/vendor/question-suggestions/${access_token}/`,
        SET_DRAFT_STATUS: (id) => `${baseUrl}compliance/compliance/organization-compliance/${id}/set-draft/`,

        // Assessment Settings APIs (same endpoint for GET and PATCH)
        ORGANIZATION_ASSESSMENT_SETTINGS: baseUrl + 'third-party/tprm/organization/assessment-settings/',

        // Scan Alert Risk Data
        ALERT_CHAT: baseUrl + 'third-party/tprm/alert-chat/',
        ALERT_CHAT_INITIALIZE: ({ organization_id }) => {
            let url = `${baseUrl}third-party/tprm/alert-chat/initialize/`;
            const params = new URLSearchParams();
            if (organization_id) {
                params.append('organization_id', organization_id);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        SCAN_ALERT_RISK_DATA: ({ organization_id }) => {
            let url = `${baseUrl}third-party/tprm/scan-alert-risk-data/list/`;
            const params = new URLSearchParams();
            if (organization_id) {
                params.append('organization_id', organization_id);
            }
            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            return url;
        },
        GET_QUESTIONNAIRES: baseUrl + 'third-party/tprm/organization/questionnaires/',
        FIELDS_MEASURES_METADATA: baseUrl + 'third-party/tprm/fields-measures-metadata/',
        FIELDS_MEASURES_METADATA_UPSERT: baseUrl + 'third-party/tprm/fields-measures-metadata/upsert/',
        FIELDS_MEASURES_METADATA_DELETE: (metadata_id) => `${baseUrl}third-party/tprm/fields-measures-metadata/${metadata_id}/`,

        // Report Email Recipients
        REPORT_EMAIL_RECIPIENTS: baseUrl + 'scanner/report-email-recipients/',
        REPORT_EMAIL_RECIPIENT_BY_ID: (id) => `${baseUrl}scanner/report-email-recipients/${id}/`,

        // Org Members
        GET_ORG_MEMBERS: baseUrl + 'auth/org-members/',
        ADD_ORG_MEMBER: baseUrl + 'auth/org-members/add/',
        UPDATE_ORG_MEMBER: (id) => `${baseUrl}auth/org-members/${id}/`,
        DELETE_ORG_MEMBER: (id) => `${baseUrl}auth/org-members/${id}/`,

        // Platform Users (super_admin only — role_slug: sub_admin | tam | mssp)
        GET_PLATFORM_USERS: baseUrl + 'auth/platform-users/',
        ADD_PLATFORM_USER: baseUrl + 'auth/platform-users/',

        // Role Assignments (super_admin only)
        ASSIGN_ROLE: baseUrl + 'auth/super-admin/role-assignments/',
        UNASSIGN_ROLE: (assignmentId) => `${baseUrl}auth/super-admin/role-assignments/${assignmentId}/`,

        // Super Admin — Plan Management
        GET_PLANS: baseUrl + 'auth/super-admin/plans/',
        CREATE_PLAN: baseUrl + 'auth/super-admin/plans/',
        UPDATE_PLAN: (id) => `${baseUrl}auth/super-admin/plans/${id}/`,
        DELETE_PLAN: (id) => `${baseUrl}auth/super-admin/plans/${id}/`,

        // Super Admin — Org Plan Allocation
        GET_ORG_PLAN: (orgId) => `${baseUrl}auth/super-admin/org-plan-allocation/${orgId}/`,
        ASSIGN_ORG_PLAN: (orgId) => `${baseUrl}auth/super-admin/org-plan-allocation/${orgId}/`,
        ADD_TRIAL_DAYS: (orgId) => `${baseUrl}auth/super-admin/org-plan-allocation/${orgId}/`,

        // Super Admin — Available Permissions
        GET_PERMISSIONS: baseUrl + 'auth/super-admin/permissions/',

        // Admin - Cloud Data Population
        POPULATE_AWS_DATA: baseUrl.replace('nmt/api/v1/', '') + 'admin/populate-aws-data/',
        POPULATE_AZURE_DATA: baseUrl.replace('nmt/api/v1/', '') + 'admin/populate-azure-data/',
        POPULATE_GCP_DATA: baseUrl.replace('nmt/api/v1/', '') + 'admin/populate-gcp-data/',
        POPULATE_ONPREM_DATA: baseUrl.replace('nmt/api/v1/', '') + 'admin/populate-onprem-data/',

        // SBOM Endpoints — uses sbomBaseUrl (resolved from REACT_APP_API_URL)
        SBOM_DASHBOARD: sbomBaseUrl + 'scanner/sbom/dashboard/',
        SBOM_REPORTS: sbomBaseUrl + 'scanner/sbom/reports/',
        SBOM_REPORT_DETAIL: (reportId) => `${sbomBaseUrl}scanner/sbom/reports/${reportId}/`,
        SBOM_REPORT_EXPORT: (reportId) => `${sbomBaseUrl}scanner/sbom/reports/${reportId}/export/`,
        SBOM_GENERATE: sbomBaseUrl + 'scanner/sbom/reports/generate/',
        SBOM_UPLOAD: sbomBaseUrl + 'scanner/sbom/reports/upload/',
        SBOM_COMPONENTS: ({ report_id, type, license_risk, search, outdated, has_vulns, page, page_size, sort }) => {
            let url = `${sbomBaseUrl}scanner/sbom/components/`;
            const params = new URLSearchParams();
            if (report_id) params.append('report_id', report_id);
            if (type) params.append('type', type);
            if (license_risk) params.append('license_risk', license_risk);
            if (search) params.append('search', search);
            if (outdated) params.append('outdated', outdated);
            if (has_vulns) params.append('has_vulns', has_vulns);
            if (page) params.append('page', page);
            if (page_size) params.append('page_size', page_size);
            if (sort) params.append('sort', sort);
            if ([...params].length > 0) url += `?${params.toString()}`;
            return url;
        },
        SBOM_COMPONENT_DETAIL: (componentId) => `${sbomBaseUrl}scanner/sbom/components/${componentId}/`,
        SBOM_COMPONENT_TREE: (componentId) => `${sbomBaseUrl}scanner/sbom/components/${componentId}/tree/`,
        SBOM_IMPACT_SEARCH: ({ package_name, version }) => {
            let url = `${sbomBaseUrl}scanner/sbom/impact-search/`;
            const params = new URLSearchParams();
            if (package_name) params.append('package_name', package_name);
            if (version) params.append('version', version);
            if ([...params].length > 0) url += `?${params.toString()}`;
            return url;
        },
        SBOM_AGENTS: sbomBaseUrl + 'scanner/sbom/agents/',
        SBOM_SCAN_SSH: sbomBaseUrl + 'scanner/sbom/scan-ssh/',
        SBOM_SCAN_CLOUD: sbomBaseUrl + 'scanner/sbom/scan-cloud/',
        SBOM_INGEST_AGENT: sbomBaseUrl + 'scanner/sbom/ingest-agent/',
        SBOM_CI_CD_WEBHOOK: sbomBaseUrl + 'scanner/sbom/webhook/ci-cd/',
        SBOM_SETUP_SNIPPETS: sbomBaseUrl + 'scanner/sbom/setup-snippets/',
        // VEX
        SBOM_VEX_CREATE: sbomBaseUrl + 'scanner/sbom/vex/create/',
        SBOM_VEX_LIST: (reportId) => `${sbomBaseUrl}scanner/sbom/vex/list/${reportId ? '?report_id=' + reportId : ''}`,
        SBOM_VEX_EXPORT: (reportId, format) => `${sbomBaseUrl}scanner/sbom/vex/export/?vex_format=${format || 'openvex'}${reportId ? '&report_id=' + reportId : ''}`,
        // Policies
        SBOM_POLICIES: sbomBaseUrl + 'scanner/sbom/policies/',
        SBOM_POLICY_CREATE: sbomBaseUrl + 'scanner/sbom/policies/create/',
        SBOM_POLICY_TOGGLE: (policyId) => `${sbomBaseUrl}scanner/sbom/policies/${policyId}/toggle/`,
        SBOM_POLICY_DELETE: (policyId) => `${sbomBaseUrl}scanner/sbom/policies/${policyId}/delete/`,
        SBOM_POLICY_INIT_DEFAULTS: sbomBaseUrl + 'scanner/sbom/policies/init-defaults/',
        SBOM_POLICY_EVALUATE: sbomBaseUrl + 'scanner/sbom/policies/evaluate/',
        SBOM_VIOLATIONS: sbomBaseUrl + 'scanner/sbom/violations/',
        // PDF/HTML Export
        SBOM_ENRICH: (reportId) => `${sbomBaseUrl}scanner/sbom/reports/${reportId}/enrich/`,
        SBOM_ENRICH_LICENSES: (reportId) => `${sbomBaseUrl}scanner/sbom/reports/${reportId}/enrich-licenses/`,
        SBOM_ENRICH_LICENSES_ALL: sbomBaseUrl + 'scanner/sbom/enrich-licenses-all/',
        SBOM_RISK_TREND: (days) => `${sbomBaseUrl}scanner/sbom/risk-trend/?days=${days || 90}`,
        SBOM_RISK_SNAPSHOT: sbomBaseUrl + 'scanner/sbom/risk-trend/snapshot/',
        SBOM_DASHBOARD_ENHANCED: sbomBaseUrl + 'scanner/sbom/dashboard-enhanced/',
        SBOM_COMPLIANCE_EVALUATE: sbomBaseUrl + 'scanner/sbom/compliance/evaluate/',
        SBOM_COMPLIANCE_SCORES: sbomBaseUrl + 'scanner/sbom/compliance/scores/',
        SBOM_SCHEDULES: sbomBaseUrl + 'scanner/sbom/schedules/',
        SBOM_SCHEDULE_CREATE: sbomBaseUrl + 'scanner/sbom/schedules/create/',
        SBOM_SCHEDULE_TOGGLE: (id) => `${sbomBaseUrl}scanner/sbom/schedules/${id}/toggle/`,
        SBOM_SCHEDULE_DELETE: (id) => `${sbomBaseUrl}scanner/sbom/schedules/${id}/delete/`,
        SBOM_AUDIT_LOG: sbomBaseUrl + 'scanner/sbom/audit-log/',
        SBOM_DIFF: (reportA, reportB) => `${sbomBaseUrl}scanner/sbom/reports/diff/?report_a=${reportA}&report_b=${reportB}`,
        SBOM_VERSIONS: (agentName) => `${sbomBaseUrl}scanner/sbom/reports/versions/${agentName ? '?agent_name=' + agentName : ''}`,
        SBOM_EXPORT_PDF: (reportId) => `${sbomBaseUrl}scanner/sbom/reports/${reportId}/export-pdf/`,
        SBOM_EXPORT_HTML: (reportId) => `${sbomBaseUrl}scanner/sbom/reports/${reportId}/export-html/`,
        SBOM_LICENSE_SUMMARY: sbomBaseUrl + 'scanner/sbom/licenses/summary/',
        SBOM_DRIFT: ({ change_type, days, search, page, page_size }) => {
            let url = `${sbomBaseUrl}scanner/sbom/drift/`;
            const params = new URLSearchParams();
            if (change_type) params.append('change_type', change_type);
            if (days) params.append('days', days);
            if (search) params.append('search', search);
            if (page) params.append('page', page);
            if (page_size) params.append('page_size', page_size);
            if ([...params].length > 0) url += `?${params.toString()}`;
            return url;
        },

        // AI Governance Endpoints — uses aigBaseUrl (resolved from REACT_APP_API_URL)
        AIG_DASHBOARD: aigBaseUrl + 'ai-governance/dashboard/',
        AIG_SCAN: aigBaseUrl + 'ai-governance/scan/',
        AIG_ASSETS: aigBaseUrl + 'ai-governance/assets/',
        AIG_SHADOW_ASSETS: aigBaseUrl + 'ai-governance/assets/shadow/',
        AIG_APPROVE_ASSET: (id) => `${aigBaseUrl}ai-governance/assets/${id}/approve/`,
        AIG_BLOCK_ASSET: (id) => `${aigBaseUrl}ai-governance/assets/${id}/block/`,
        AIG_CLASSIFY_ASSET: (id) => `${aigBaseUrl}ai-governance/assets/${id}/classify/`,
        AIG_POLICIES: aigBaseUrl + 'ai-governance/policies/',
        AIG_POLICY_CREATE: aigBaseUrl + 'ai-governance/policies/create/',
        AIG_POLICY_INIT_DEFAULTS: aigBaseUrl + 'ai-governance/policies/init-defaults/',
        AIG_VIOLATIONS: aigBaseUrl + 'ai-governance/violations/',
        AIG_SIGNATURES: aigBaseUrl + 'ai-governance/signatures/',
        AIG_LOAD_SIGNATURES: aigBaseUrl + 'ai-governance/signatures/load-defaults/',
        AIG_TRENDS: (days) => `${aigBaseUrl}ai-governance/trends/?days=${days || 90}`,
        AIG_TRENDS_SNAPSHOT: aigBaseUrl + 'ai-governance/trends/snapshot/',
        AIG_COMPLIANCE_EVALUATE: aigBaseUrl + 'ai-governance/compliance/evaluate/',
        AIG_COMPLIANCE_SCORES: aigBaseUrl + 'ai-governance/compliance/scores/',
        AIG_RISK_ASSESS_ALL: aigBaseUrl + 'ai-governance/risk/assess-all/',
        AIG_RISK_SCORES: aigBaseUrl + 'ai-governance/risk/scores/',
        // DLP
        AIG_DLP_EVENTS: aigBaseUrl + 'ai-governance/dlp/events/',
        AIG_DLP_SUMMARY: (hours) => `${aigBaseUrl}ai-governance/dlp/events/summary/?hours=${hours || 24}`,
        AIG_DLP_INTEGRATIONS: aigBaseUrl + 'ai-governance/dlp/integrations/',
        AIG_DLP_CREATE_INTEGRATION: aigBaseUrl + 'ai-governance/dlp/integrations/create/',
        AIG_DLP_UPDATE_INTEGRATION: (id) => `${aigBaseUrl}ai-governance/dlp/integrations/${id}/update/`,
        AIG_DLP_WEBHOOK: aigBaseUrl + 'ai-governance/dlp/webhook/',

        // AI Governance — Audit & Schedules
        AIG_WHITELIST: aigBaseUrl + 'ai-governance/whitelist/',
        AIG_WHITELIST_ADD: aigBaseUrl + 'ai-governance/whitelist/add/',
        AIG_WHITELIST_REMOVE: (id) => `${aigBaseUrl}ai-governance/whitelist/${id}/remove/`,
        AIG_EXCEPTION_REQUESTS: aigBaseUrl + 'ai-governance/exception-requests/',
        AIG_EXCEPTION_CREATE: aigBaseUrl + 'ai-governance/exception-requests/create/',
        AIG_EXCEPTION_REVIEW: (id) => `${aigBaseUrl}ai-governance/exception-requests/${id}/review/`,
        AIG_ENFORCE_BLOCK: aigBaseUrl + 'ai-governance/enforce-block/',
        AIG_ENFORCEMENT_INTEGRATIONS: aigBaseUrl + 'ai-governance/enforcement_integrations/',
        AIG_ENFORCEMENT_SAVE: aigBaseUrl + 'ai-governance/enforcement_integration_save/',
        AIG_ENFORCEMENT_DELETE: aigBaseUrl + 'ai-governance/enforcement_integration_delete/',
        AIG_ENFORCEMENT_TEST: aigBaseUrl + 'ai-governance/enforcement_integration_test/',
        AIG_USER_PROFILES: aigBaseUrl + 'ai-governance/user-profiles/',
        AIG_BLOCKLIST_EXPORT: (format, scope) => `${aigBaseUrl}ai-governance/blocklist-download/?export_format=${format}&scope=${scope || 'blocked'}`,
        AIG_BLOCKLIST_FORMATS: aigBaseUrl + 'ai-governance/blocklist/formats/',
        AIG_AUDIT_LOG: aigBaseUrl + 'ai-governance/audit-log/',
        AIG_SCHEDULES: aigBaseUrl + 'ai-governance/schedules/',
        AIG_SCHEDULE_CREATE: aigBaseUrl + 'ai-governance/schedules/create/',
        AIG_SCHEDULE_TOGGLE: (id) => `${aigBaseUrl}ai-governance/schedules/${id}/toggle/`,
        AIG_SCHEDULE_DELETE: (id) => `${aigBaseUrl}ai-governance/schedules/${id}/delete/`,
        AIG_EXPORT_ASSETS: aigBaseUrl + 'ai-governance/assets/export/',
        AIG_AIBOM_EXPORT: (fmt) => `${aigBaseUrl}ai-governance/aibom/export/?export_format=${fmt || 'cyclonedx'}`,

        // Internal Audit
        AUDIT_DASHBOARD: aigBaseUrl + 'audit/dashboard/',
        AUDIT_MY_TASKS: aigBaseUrl + 'audit/dashboard/my-tasks/',
        AUDIT_FRAMEWORKS: aigBaseUrl + 'audit/frameworks/',
        AUDIT_CREATE_FRAMEWORK: aigBaseUrl + 'audit/frameworks/create/',
        AUDIT_DELETE_FRAMEWORK: (id) => `${aigBaseUrl}audit/frameworks/${id}/delete/`,
        AUDIT_UPDATE_FRAMEWORK: (id) => `${aigBaseUrl}audit/frameworks/${id}/update/`,
        AUDIT_FRAMEWORK_CONTROLS: (id) => `${aigBaseUrl}audit/frameworks/${id}/controls/`,
        AUDIT_DOWNLOAD_TEMPLATE: aigBaseUrl + 'audit/frameworks/upload-template/',
        AUDIT_PREVIEW_HEADERS: (id) => `${aigBaseUrl}audit/frameworks/${id}/preview-headers/`,
        AUDIT_UPLOAD_CONTROLS: (id) => `${aigBaseUrl}audit/frameworks/${id}/upload-controls/`,
        AUDIT_EXPORT_CONTROLS: (id) => `${aigBaseUrl}audit/frameworks/${id}/export-controls/`,
        AUDIT_BU_LIST: aigBaseUrl + 'audit/business-units/',
        AUDIT_BU_CREATE: aigBaseUrl + 'audit/business-units/create/',
        AUDIT_BU_UPDATE: (id) => `${aigBaseUrl}audit/business-units/${id}/update/`,
        AUDIT_PORTAL_INVITE: aigBaseUrl + 'audit/portal/invite/',
        AUDIT_PORTAL_REGISTER: aigBaseUrl + 'audit/portal/register/',
        AUDIT_PORTAL_LOGIN: aigBaseUrl + 'audit/portal/login/',
        AUDIT_PORTAL_FORGOT_PASSWORD: aigBaseUrl + 'audit/portal/forgot-password/',
        AUDIT_PORTAL_RESET_PASSWORD: aigBaseUrl + 'audit/portal/reset-password/',
        AUDIT_PORTAL_USERS: aigBaseUrl + 'audit/portal/users/',
        AUDIT_PORTAL_USER_UPDATE: (id) => `${aigBaseUrl}audit/portal/users/${id}/update/`,
        AUDIT_PORTAL_USER_DELETE: (id) => `${aigBaseUrl}audit/portal/users/${id}/delete/`,
        AUDIT_USER_MODULES: aigBaseUrl + 'audit/user/modules/',
        AUDIT_PORTAL_AD_SYNC: aigBaseUrl + 'audit/portal/ad-sync/',
        AUDIT_PORTAL_AD_CONFIG: aigBaseUrl + 'audit/portal/ad-config/',
        AUDIT_WORKFLOW_CONFIG: aigBaseUrl + 'audit/workflow-config/',
        AUDIT_WORKFLOW_CONFIG_UPDATE: aigBaseUrl + 'audit/workflow-config/update/',
        AUDIT_WORKFLOW_CONFIG_RESET: aigBaseUrl + 'audit/workflow-config/reset/',
        AUDIT_WORKFLOW_CONFIG_APPLY_TEMPLATE: aigBaseUrl + 'audit/workflow-config/apply-template/',
        AUDIT_PROJECTS: aigBaseUrl + 'audit/projects/',
        AUDIT_PROJECT_CREATE: aigBaseUrl + 'audit/projects/create/',
        AUDIT_PROJECT_UPDATE: (id) => `${aigBaseUrl}audit/projects/${id}/update/`,
        AUDIT_PROJECT_DELETE: (id) => `${aigBaseUrl}audit/projects/${id}/delete/`,
        AUDIT_LIST: aigBaseUrl + 'audit/audits/',
        AUDIT_CREATE: aigBaseUrl + 'audit/audits/create/',
        AUDIT_DETAIL: (id) => `${aigBaseUrl}audit/audits/${id}/`,
        AUDIT_QUESTIONS: (id) => `${aigBaseUrl}audit/audits/${id}/questions/`,
        AUDIT_AUDITEE_PROGRESS: (id) => `${aigBaseUrl}audit/audits/${id}/auditee-progress/`,
        AUDIT_RESPOND: (auditId, controlId) => `${aigBaseUrl}audit/audits/${auditId}/respond/${controlId}/`,
        AUDIT_REVIEW: (auditId, controlId) => `${aigBaseUrl}audit/audits/${auditId}/review/${controlId}/`,
        AUDIT_REVIEW_BULK: (auditId) => `${aigBaseUrl}audit/audits/${auditId}/review/bulk/`,
        AUDIT_FINDINGS: (id) => `${aigBaseUrl}audit/audits/${id}/findings/`,
        AUDIT_CREATE_FINDING: (id) => `${aigBaseUrl}audit/audits/${id}/findings/create/`,
        AUDIT_POLICIES: aigBaseUrl + 'audit/policies/',
        AUDIT_CREATE_POLICY: aigBaseUrl + 'audit/policies/create/',
        AUDIT_SUBMIT_POLICY: (id) => `${aigBaseUrl}audit/policies/${id}/submit/`,
        AUDIT_APPROVE_POLICY: (id) => `${aigBaseUrl}audit/policies/${id}/approve/`,
        AUDIT_WORKFLOWS: aigBaseUrl + 'audit/workflows/',
        AUDIT_CREATE_WORKFLOW: aigBaseUrl + 'audit/workflows/create/',
        AUDIT_NOTIFICATIONS: aigBaseUrl + 'audit/notifications/',
        AUDIT_BULK_ASSESS: (id) => `${aigBaseUrl}audit/audits/${id}/bulk-assess/`,
        AUDIT_SUBMIT_FINDINGS: (id) => `${aigBaseUrl}audit/audits/${id}/submit-findings/`,
        AUDIT_GENERATE_REPORT: (id) => `${aigBaseUrl}audit/audits/${id}/generate-report/`,
        AUDIT_ISSUE_AGING: aigBaseUrl + 'audit/issue-aging/',
        AUDIT_EVIDENCE_REQUEST: aigBaseUrl + 'audit/evidence/request/',
        AUDIT_MANAGEMENT_RESPONSE: (id) => `${aigBaseUrl}audit/findings/${id}/management-response/`,
        AUDIT_VERIFY_FINDING: (id) => `${aigBaseUrl}audit/findings/${id}/verify/`,
        AUDIT_UNIVERSE: aigBaseUrl + 'audit/audit-universe/',
        AUDIT_EVIDENCE_UPLOAD: aigBaseUrl + 'audit/evidence/upload/',
        AUDIT_EVIDENCE_DOWNLOAD: (id) => `${aigBaseUrl}audit/evidence/${id}/`,
        AUDIT_FIELD_HISTORY: (id) => `${aigBaseUrl}audit/audits/${id}/field-history/`,
        AUDIT_APPROVAL_STATUS: (id) => `${aigBaseUrl}audit/audits/${id}/approval-status/`,
        AUDIT_APPROVE_STAGE: (id) => `${aigBaseUrl}audit/audits/${id}/approve-stage/`,
        AUDIT_EVIDENCE_REQUESTS: (id) => `${aigBaseUrl}audit/audits/${id}/evidence-requests/`,
        AUDIT_EVIDENCE_REQUEST_CREATE: (id) => `${aigBaseUrl}audit/audits/${id}/evidence-requests/create/`,
        AUDIT_EVIDENCE_REQUEST_SUBMIT: (id) => `${aigBaseUrl}audit/evidence-requests/${id}/submit/`,
        AUDIT_EVIDENCE_REQUEST_REVIEW: (id) => `${aigBaseUrl}audit/evidence-requests/${id}/review/`,

        // Audit Admin — Custom Fields
        AUDIT_CUSTOM_FIELDS: aigBaseUrl + 'audit/custom-fields/',
        AUDIT_CUSTOM_FIELD_CREATE: aigBaseUrl + 'audit/custom-fields/create/',
        AUDIT_CUSTOM_FIELD_UPDATE: (id) => `${aigBaseUrl}audit/custom-fields/${id}/update/`,
        AUDIT_CUSTOM_FIELD_DELETE: (id) => `${aigBaseUrl}audit/custom-fields/${id}/delete/`,
        AUDIT_CUSTOM_FIELD_REORDER: aigBaseUrl + 'audit/custom-fields/reorder/',
        AUDIT_CUSTOM_FIELD_SAVE_VALUES: aigBaseUrl + 'audit/custom-fields/save-values/',
        AUDIT_CUSTOM_FIELD_VALUES: aigBaseUrl + 'audit/custom-fields/values/',

        // Audit Admin — Workflow CRUD
        AUDIT_UPDATE_WORKFLOW: (id) => `${aigBaseUrl}audit/workflows/${id}/update/`,
        AUDIT_DELETE_WORKFLOW: (id) => `${aigBaseUrl}audit/workflows/${id}/delete/`,

        // Audit — Users
        AUDIT_USERS: aigBaseUrl + 'audit/users/',
        AUDIT_INVITE_USER: aigBaseUrl + 'audit/users/invite/',
        AUDIT_UPDATE_USER: (id) => `${aigBaseUrl}audit/users/${id}/update/`,
        AUDIT_DEACTIVATE_USER: (id) => `${aigBaseUrl}audit/users/${id}/deactivate/`,

        // Audit Admin — Org Config
        AUDIT_CONFIG: aigBaseUrl + 'audit/config/',
        AUDIT_CONFIG_UPDATE: aigBaseUrl + 'audit/config/update/',

        // Audit Lifecycle
        AUDIT_UPDATE: (id) => `${aigBaseUrl}audit/audits/${id}/update/`,
        AUDIT_ASSIGN: (id) => `${aigBaseUrl}audit/audits/${id}/assign/`,
        AUDIT_ADVANCE_STAGE: (id) => `${aigBaseUrl}audit/audits/${id}/advance-stage/`,
        AUDIT_PROGRESS: (id) => `${aigBaseUrl}audit/audits/${id}/progress/`,
        AUDIT_TIMELINE: (id) => `${aigBaseUrl}audit/audits/${id}/timeline/`,
        AUDIT_CLOSE: (id) => `${aigBaseUrl}audit/audits/${id}/close/`,
        AUDIT_DELETE: (id) => `${aigBaseUrl}audit/audits/${id}/delete/`,
        AUDIT_COMPLETE: (id) => `${aigBaseUrl}audit/audits/${id}/complete/`,
        AUDIT_SIGN_OFF: (id) => `${aigBaseUrl}audit/audits/${id}/sign-off/`,
        AUDIT_BULK_ASSIGN_QUESTIONS: (id) => `${aigBaseUrl}audit/audits/${id}/bulk-assign/`,
        AUDIT_ASSIGN_CONTROLS: `${aigBaseUrl}audit/audits/assign/`,
        AUDIT_EXPORT_RESPONSES: (id) => `${aigBaseUrl}audit/audits/${id}/responses/export/`,

        // Finding Lifecycle
        AUDIT_UPDATE_FINDING: (id) => `${aigBaseUrl}audit/findings/${id}/update/`,
        AUDIT_REMEDIATE_FINDING: (id) => `${aigBaseUrl}audit/findings/${id}/remediate/`,
        AUDIT_ACCEPT_RISK: (id) => `${aigBaseUrl}audit/findings/${id}/accept-risk/`,
        AUDIT_CREATE_RISK_FROM_FINDING: (id) => `${aigBaseUrl}audit/findings/${id}/create-risk/`,

        // Evidence
        AUDIT_DELETE_EVIDENCE: (id) => `${aigBaseUrl}audit/evidence/${id}/delete/`,

        // Policy Lifecycle
        AUDIT_UPDATE_POLICY: (id) => `${aigBaseUrl}audit/policies/${id}/update/`,
        AUDIT_POLICY_VERSIONS: (id) => `${aigBaseUrl}audit/policies/${id}/versions/`,
        AUDIT_POLICY_ACKNOWLEDGE: (id) => `${aigBaseUrl}audit/policies/${id}/acknowledge/`,
        AUDIT_POLICY_ACK_STATUS: (id) => `${aigBaseUrl}audit/policies/${id}/acknowledgement-status/`,

        // Internal Audit Enhancements
        AUDIT_CLONE: (id) => `${aigBaseUrl}audit/audits/${id}/clone/`,
        AUDIT_LINKED: (id) => `${aigBaseUrl}audit/audits/${id}/linked/`,
        AUDIT_RECURRING_SCHEDULES: aigBaseUrl + 'audit/recurring-schedules/',
        AUDIT_RECURRING_SCHEDULE_DETAIL: (id) => `${aigBaseUrl}audit/recurring-schedules/${id}/`,
        AUDIT_SCOPE_TREE: (id) => `${aigBaseUrl}audit/frameworks/${id}/scope-tree/`,
        AUDIT_UPDATE_SCOPE: (id) => `${aigBaseUrl}audit/audits/${id}/update-scope/`,
        AUDIT_ADD_FRAMEWORK: (id) => `${aigBaseUrl}audit/audits/${id}/add-framework/`,
        AUDIT_MULTI_FRAMEWORKS: (id) => `${aigBaseUrl}audit/audits/${id}/frameworks/`,
        AUDIT_COMPARE: (id, prevId) => `${aigBaseUrl}audit/audits/${id}/compare/${prevId}/`,
        AUDIT_CAPAS: aigBaseUrl + 'audit/capas/',
        AUDIT_CAPA_UPDATE: (id) => `${aigBaseUrl}audit/capas/${id}/`,
        AUDIT_CAPA_DELETE: (id) => `${aigBaseUrl}audit/capas/${id}/`,
        AUDIT_CAPA_HISTORY: (id) => `${aigBaseUrl}audit/capas/${id}/history/`,
        AUDIT_CAPA_BULK_UPDATE: aigBaseUrl + 'audit/capas/bulk-update/',
        AUDIT_CAPA_EXPORT: aigBaseUrl + 'audit/capas/export/',
        AUDIT_MANAGEMENT_SUMMARY: aigBaseUrl + 'audit/management-summary/',
        AUDIT_CHECK_RECURRING_FINDING: (auditId, controlId) => `${aigBaseUrl}audit/findings/check-recurring/${auditId}/${controlId}/`,
        AUDIT_SCORING_MODEL: (id) => `${aigBaseUrl}audit/audits/${id}/scoring-model/`,
        AUDIT_MATURITY_SCORE: (auditId, controlId) => `${aigBaseUrl}audit/audits/${auditId}/maturity-score/${controlId}/`,
        AUDIT_CALENDAR: aigBaseUrl + 'audit/calendar/',
        AUDIT_CALENDAR_ENTRY: (id) => `${aigBaseUrl}audit/calendar/${id}/`,
        AUDIT_CALENDAR_CONVERT: (id) => `${aigBaseUrl}audit/calendar/${id}/convert/`,
        AUDIT_CALENDAR_EXPORT: aigBaseUrl + 'audit/calendar/export/',

        // KRI Matrix
        // KPI Importer
        USER_MODULES: aigBaseUrl + 'audit/user/modules/',
        KPI_PREVIEW: aigBaseUrl + 'audit/kpi/preview/',
        KPI_IMPORT: aigBaseUrl + 'audit/kpi/import/',
        // KPI CRUD (new model)
        KPIS_LIST: aigBaseUrl + 'audit/kpis/list/',
        KPIS_CREATE: aigBaseUrl + 'audit/kpis/create/',
        KPIS_UPDATE: (id) => `${aigBaseUrl}audit/kpis/${id}/`,
        KPIS_DELETE: (id) => `${aigBaseUrl}audit/kpis/${id}/`,
        KPIS_ACKNOWLEDGE: (id) => `${aigBaseUrl}audit/kpis/${id}/acknowledge/`,
        KPIS_EVIDENCE: (id) => `${aigBaseUrl}audit/kpis/${id}/evidence/`,
        KPIS_HISTORY: (id) => `${aigBaseUrl}audit/kpis/${id}/history/`,
        KPIS_BULK_UPDATE: aigBaseUrl + 'audit/kpis/bulk-update/',
        KPI_ACKNOWLEDGE: (id) => `${aigBaseUrl}audit/kpi/acknowledge/${id}/`,
        KPI_MY_KPIS: aigBaseUrl + 'audit/kpi/my-kpis/',
        KPI_TEMPLATE: aigBaseUrl + 'audit/kpi/template/',
        KPI_UPDATE: (id) => `${aigBaseUrl}audit/kpi/update/${id}/`,
        KPI_UPLOAD_EVIDENCE: (id) => `${aigBaseUrl}audit/kpi/update/${id}/evidence/`,
        KPI_LIBRARY: aigBaseUrl + 'audit/kpi/library/',
        KPI_LIBRARY_IMPORT: aigBaseUrl + 'audit/kpi/library/import/',
        KPI_SNAPSHOT: aigBaseUrl + 'audit/kpi/snapshot/',
        KPI_TRENDS: aigBaseUrl + 'audit/kpi/trends/',
        KPIS_PURGE: (id) => `${aigBaseUrl}audit/kpis/${id}/purge/`,
        KPIS_BULK_ARCHIVE: aigBaseUrl + 'audit/kpis/bulk-archive/',
        KPIS_BULK_PURGE: aigBaseUrl + 'audit/kpis/bulk-purge/',
        KPIS_UPDATES: (id) => `${aigBaseUrl}audit/kpis/${id}/updates/`,
        KPI_ADMINS_LIST: aigBaseUrl + 'audit/kpis/admins/',
        KPI_ADMINS_REVOKE: (email) => `${aigBaseUrl}audit/kpis/admins/${encodeURIComponent(email)}/revoke/`,
        KPI_ORG_CONFIG: aigBaseUrl + 'audit/kpis/config/',
        KPIS_ASSIGN_OWNER: (id) => `${aigBaseUrl}audit/kpis/${id}/assign-owner/`,
        KPIS_BULK_ASSIGN: aigBaseUrl + 'audit/kpis/bulk-assign/',
        KPIS_ESCALATIONS: aigBaseUrl + 'audit/kpis/escalations/',
        KPIS_ESCALATE: aigBaseUrl + 'audit/kpis/escalate/',
        KPIS_EXPORT: aigBaseUrl + 'audit/kpis/export/',
        KPIS_DEDUPE: aigBaseUrl + 'audit/kpis/dedupe/',
        KPIS_RESTORE: (id) => `${aigBaseUrl}audit/kpis/${id}/restore/`,
        KPIS_AI_SUMMARISE_QUARTER: aigBaseUrl + 'audit/kpis/ai-summarise-quarter/',
        KPIS_AI_EXPLAIN_GAP: (id) => `${aigBaseUrl}audit/kpis/${id}/ai-explain-gap/`,
        KPIS_EVIDENCE_LIST: (kpiId) => `${aigBaseUrl}audit/kpis/${kpiId}/evidence/`,
        KPIS_EVIDENCE_DELETE: (kpiId, evId) => `${aigBaseUrl}audit/kpis/${kpiId}/evidence/${evId}/`,
        KPIS_EVIDENCE_DOWNLOAD: (kpiId, evId) => `${aigBaseUrl}audit/kpis/${kpiId}/evidence/${evId}/download`,

        KRI_DASHBOARD: aigBaseUrl + 'audit/kri/dashboard/',
        KRI_TOOLS: aigBaseUrl + 'audit/kri/tools/',
        KRI_VENDORS: aigBaseUrl + 'audit/kri/vendors/',
        KRI_TOOL_CREATE: aigBaseUrl + 'audit/kri/tools/create/',
        KRI_TOOL_UPDATE: (id) => `${aigBaseUrl}audit/kri/tools/${id}/`,
        KRI_TOOL_DELETE: (id) => `${aigBaseUrl}audit/kri/tools/${id}/delete/`,
        KRI_TOOL_TEST: (id) => `${aigBaseUrl}audit/kri/tools/${id}/test/`,
        KRI_TOOL_PREVIEW: aigBaseUrl + 'audit/kri/tools/preview/',
        KRI_TOOL_PREVIEW_STATUS: aigBaseUrl + 'audit/kri/tools/preview/status/',
        KRI_TOOL_SYNC: (id) => `${aigBaseUrl}audit/kri/tools/${id}/sync/`,
        KRI_TOOL_UPLOAD_DEVICES: (id) => `${aigBaseUrl}audit/kri/tools/${id}/upload-devices/`,
        KRI_ASSETS: aigBaseUrl + 'audit/kri/assets/',
        KRI_ASSET_CREATE: aigBaseUrl + 'audit/kri/assets/create/',
        KRI_ASSET_UPLOAD: aigBaseUrl + 'audit/kri/assets/upload/',
        KRI_ASSET_DELETE: (id) => `${aigBaseUrl}audit/kri/assets/${id}/`,
        KRI_MATRIX: aigBaseUrl + 'audit/kri/matrix/',
        KRI_GAPS: aigBaseUrl + 'audit/kri/gaps/',
        KRI_GAP_REMEDIATE: (id) => `${aigBaseUrl}audit/kri/gaps/${id}/remediate/`,
        KRI_SYNC_LOGS: aigBaseUrl + 'audit/kri/sync-logs/',
        KRI_CONNECTOR_DISCOVER: aigBaseUrl + 'audit/kri/connector/discover/',
        KRI_CONNECTOR_AI_MAP: aigBaseUrl + 'audit/kri/connector/ai-map/',
        KRI_GAPS_EXPORT: aigBaseUrl + 'audit/kri/gaps/export/',
        KRI_UPLOAD_CHECKLIST: (id) => `${aigBaseUrl}audit/kri/tools/${id}/upload-checklist/`,
        KRI_TOOL_SYNC_STATUS: (id) => `${aigBaseUrl}audit/kri/tools/${id}/sync-status/`,
        KRI_TOOL_REPROCESS: (id) => `${aigBaseUrl}audit/kri/tools/${id}/reprocess/`,
        KRI_TOOL_UNMATCHED: (id) => `${aigBaseUrl}audit/kri/tools/${id}/unmatched/`,
        KRI_TOOL_UNMATCHED_ADD: (toolId, assetId) => `${aigBaseUrl}audit/kri/tools/${toolId}/unmatched/${assetId}/add/`,
        KRI_TOOL_UNMATCHED_DISMISS: (toolId, assetId) => `${aigBaseUrl}audit/kri/tools/${toolId}/unmatched/${assetId}/dismiss/`,
        KRI_DEFINITIONS: aigBaseUrl + 'audit/kri/definitions/',
        KRI_DEFINITION_CREATE: aigBaseUrl + 'audit/kri/definitions/create/',
        KRI_DEFINITION_UPDATE: (id) => `${aigBaseUrl}audit/kri/definitions/${id}/`,
        KRI_DEFINITION_DELETE: (id) => `${aigBaseUrl}audit/kri/definitions/${id}/delete/`,
        KRI_DEFINITION_TEMPLATE: aigBaseUrl + 'audit/kri/definitions/template/',
        KRI_DEFINITION_IMPORT_PREVIEW: aigBaseUrl + 'audit/kri/definitions/import/preview/',
        KRI_DEFINITION_IMPORT_COMMIT: aigBaseUrl + 'audit/kri/definitions/import/commit/',
        KRI_AI_BASELINE_REC: (id) => `${aigBaseUrl}audit/kri/tools/${id}/ai/recommend/`,
        KRI_AI_APPLY_BASELINE: (id) => `${aigBaseUrl}audit/kri/tools/${id}/ai/apply-baseline/`,
        KRI_AI_AUTO_CONFIGURE: aigBaseUrl + 'audit/kri/ai/auto-configure/',
        KRI_AI_DIAGNOSE: aigBaseUrl + 'audit/kri/ai/diagnose/',
        KRI_AI_SUGGEST_ADAPTER: aigBaseUrl + 'audit/kri/discover-tool/',
        KRI_AI_EXPLAIN_UPLOAD: (id) => `${aigBaseUrl}audit/kri/tools/${id}/ai/explain-upload/`,
        KRI_AI_SUGGEST_LABELS: (id) => `${aigBaseUrl}audit/kri/tools/${id}/ai/suggest-labels/`,
        KRI_AI_SUMMARISE: aigBaseUrl + 'audit/kri/ai-summarise-dashboard/',
        KRI_AI_COVERAGE: aigBaseUrl + 'audit/kri/ai/analyze-coverage/',
        KRI_AI_GAPS: aigBaseUrl + 'audit/kri/ai/analyze-gaps/',
        KRI_AI_BASELINE_AUDIT: aigBaseUrl + 'audit/kri/ai-audit-baseline/',
        KRI_AI_SUGGEST_URL: aigBaseUrl + 'audit/kri/ai/suggest-url/',
        KRI_TOOL_USAGE: (id) => `${aigBaseUrl}audit/kri/tools/${id}/usage/`,
        KRI_TOOL_DRIFT: (id) => `${aigBaseUrl}audit/kri/tools/${id}/drift/`,
        KRI_BASELINE_POLICIES: (id) => `${aigBaseUrl}audit/kri/tools/${id}/policies/`,
        KRI_TOOL_CANCEL_SYNC: (id) => `${aigBaseUrl}audit/kri/tools/${id}/cancel-sync/`,
        KRI_ORG_SETTINGS: aigBaseUrl + 'audit/kri/org-settings/',
        KRI_MAPPING_RULES: aigBaseUrl + 'audit/kri/asset-mapping-rules/',
        KRI_MAPPING_RULE: (id) => `${aigBaseUrl}audit/kri/asset-mapping-rules/${id}/`,
        KRI_MAPPING_RULE_APPLY: (id) => `${aigBaseUrl}audit/kri/asset-mapping-rules/${id}/apply/`,
        KRI_SAVE_SNAPSHOT: aigBaseUrl + 'audit/kri/save-snapshot/',
        KRI_TOOL_ROLLOUT_GRACE: (id) => `${aigBaseUrl}audit/kri/tools/${id}/rollout-grace/`,
        KRI_TOOL_AUDIT_LOG: (id) => `${aigBaseUrl}audit/kri/tools/${id}/audit-log/`,
        // Trust Center
        // Endpoint / Wazuh Config
        SBOM_WAZUH_CONFIG_GET: sbomBaseUrl + 'scanner/sbom/wazuh-config/',
        SBOM_WAZUH_CONFIG_SAVE: sbomBaseUrl + 'scanner/sbom/wazuh-config/save/',
        SBOM_WAZUH_CONFIG_TEST: sbomBaseUrl + 'scanner/sbom/wazuh-config/test/',
        SBOM_WAZUH_CONFIG_DISABLE: sbomBaseUrl + 'scanner/sbom/wazuh-config/disable/',
        SBOM_WAZUH_CONFIG_DELETE: sbomBaseUrl + 'scanner/sbom/wazuh-config/delete/',

        // Ops Search
        OPS_SEARCH: (q, type) => `${sbomBaseUrl}scanner/sbom/ops/search/?q=${encodeURIComponent(q)}${type ? '&type=' + type : ''}`,
        OPS_ASSETS: sbomBaseUrl + 'scanner/sbom/ops/assets/',

        TC_CONFIG: tcBaseUrl + 'trust-center/admin/config/',
        TC_SETUP: tcBaseUrl + 'trust-center/admin/setup/',
        TC_PUBLISH: tcBaseUrl + 'trust-center/admin/publish/',
        TC_PAGES: tcBaseUrl + 'trust-center/admin/pages/',
        TC_PAGE_UPDATE: (id) => `${tcBaseUrl}trust-center/admin/pages/${id}/update/`,
        TC_CERTIFICATIONS: tcBaseUrl + 'trust-center/admin/certifications/',
        TC_CERTIFICATION_CREATE: tcBaseUrl + 'trust-center/admin/certifications/create/',
        TC_SUB_PROCESSORS: tcBaseUrl + 'trust-center/admin/sub-processors/',
        TC_SUB_PROCESSOR_CREATE: tcBaseUrl + 'trust-center/admin/sub-processors/create/',
        TC_INIT_PRACTICES: tcBaseUrl + 'trust-center/admin/practices/init-defaults/',
        TC_ACCESS_REQUESTS: tcBaseUrl + 'trust-center/admin/access-requests/',
        TC_APPROVE_REQUEST: (id) => `${tcBaseUrl}trust-center/admin/access-requests/${id}/approve/`,
        TC_REJECT_REQUEST: (id) => `${tcBaseUrl}trust-center/admin/access-requests/${id}/reject/`,
        TC_ANALYTICS: tcBaseUrl + 'trust-center/admin/analytics/',
        TC_NOTIF_CONFIG: tcBaseUrl + 'trust-center/admin/notifications/config/',
        TC_NOTIF_UPDATE: tcBaseUrl + 'trust-center/admin/notifications/config/update/',
        TC_NOTIF_TEST: tcBaseUrl + 'trust-center/admin/notifications/test/',

        // translation 
        BRAND_PROTECTION_MENTION_TRANSLATE: (id) => baseUrl + `scanner/brand-protection/mentions/${id}/translate/`,
        BRAND_PROTECTION_MENTION_COMMENTS:  (id) => baseUrl + `scanner/brand-protection/mentions/${id}/comments/`,


        // Risk Registry Portal
        RISK_PORTAL_DASHBOARD: aigBaseUrl + 'risk-portal/dashboard/',
        RISK_PORTAL_HEATMAP: aigBaseUrl + 'risk-portal/heatmap/',
        RISK_PORTAL_RISKS: aigBaseUrl + 'risk-portal/risks/',
        RISK_PORTAL_RISK_DETAIL: (id) => `${aigBaseUrl}risk-portal/risks/${id}/`,
        RISK_PORTAL_ASSESS: (id) => `${aigBaseUrl}risk-portal/risks/${id}/assess/`,
        RISK_PORTAL_TREATMENT: (id) => `${aigBaseUrl}risk-portal/risks/${id}/treatment/`,
        RISK_PORTAL_TREATMENT_UPDATE: (id) => `${aigBaseUrl}risk-portal/treatments/${id}/`,
        RISK_PORTAL_KRI_LIST: aigBaseUrl + 'risk-portal/kris/',
        RISK_PORTAL_KRI_CREATE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/kri/`,
        RISK_PORTAL_CONTROL_ADD: (id) => `${aigBaseUrl}risk-portal/risks/${id}/control/`,
        RISK_PORTAL_CATEGORIES: aigBaseUrl + 'risk-portal/categories/',
        RISK_PORTAL_CATEGORY_CREATE: aigBaseUrl + 'risk-portal/categories/create/',
        RISK_PORTAL_APPETITE: aigBaseUrl + 'risk-portal/appetite/',
        RISK_PORTAL_APPETITE_SAVE: aigBaseUrl + 'risk-portal/appetite/save/',
        RISK_PORTAL_WORKFLOW_CONFIG: aigBaseUrl + 'risk-portal/workflow-config/',
        RISK_PORTAL_WORKFLOW_UPDATE: aigBaseUrl + 'risk-portal/workflow-config/update/',
        RISK_PORTAL_USERS: aigBaseUrl + 'risk-portal/portal/users/',
        RISK_PORTAL_INVITE: aigBaseUrl + 'risk-portal/portal/invite/',
        RISK_PORTAL_LOGIN: aigBaseUrl + 'risk-portal/portal/standalone-login/',
        RISK_PORTAL_REGISTER: aigBaseUrl + 'risk-portal/portal/register/',
        RISK_PORTAL_FORGOT_PASSWORD: aigBaseUrl + 'risk-portal/portal/forgot-password/',
        RISK_PORTAL_RESET_PASSWORD: aigBaseUrl + 'risk-portal/portal/reset-password/',
        RISK_PORTAL_COMMENT: (id) => `${aigBaseUrl}risk-portal/risks/${id}/comment/`,
        RISK_PORTAL_EVIDENCE: aigBaseUrl + 'risk-portal/evidence/upload/',
        RISK_PORTAL_ACTIVITY: (id) => `${aigBaseUrl}risk-portal/risks/${id}/activity/`,
        // Phase 2
        RISK_PORTAL_TREATMENT_APPROVE: (id) => `${aigBaseUrl}risk-portal/treatments/${id}/approve/`,
        RISK_PORTAL_TREATMENT_REJECT: (id) => `${aigBaseUrl}risk-portal/treatments/${id}/reject/`,
        RISK_PORTAL_OVERDUE_TREATMENTS: aigBaseUrl + 'risk-portal/treatments/overdue/',
        RISK_PORTAL_KRI_UPDATE: (id) => `${aigBaseUrl}risk-portal/kris/${id}/`,
        RISK_PORTAL_KRI_DELETE: (id) => `${aigBaseUrl}risk-portal/kris/${id}/delete/`,
        RISK_PORTAL_FRAMEWORK_CONTROLS: aigBaseUrl + 'risk-portal/framework-controls/',
        RISK_PORTAL_FRAMEWORK_LIST: aigBaseUrl + 'risk-portal/framework-list/',
        RISK_PORTAL_CONTROL_UPDATE: (id) => `${aigBaseUrl}risk-portal/controls/${id}/`,
        RISK_PORTAL_CONTROL_DELETE: (id) => `${aigBaseUrl}risk-portal/controls/${id}/delete/`,
        RISK_PORTAL_APPETITE_BREACHES: aigBaseUrl + 'risk-portal/appetite/breaches/',
        RISK_PORTAL_VELOCITY_SUMMARY: aigBaseUrl + 'risk-portal/velocity-summary/',
        RISK_PORTAL_TREATMENT_DELETE: (id) => `${aigBaseUrl}risk-portal/treatments/${id}/delete/`,
        RISK_PORTAL_CATEGORY_DELETE: (id) => `${aigBaseUrl}risk-portal/categories/${id}/delete/`,
        RISK_PORTAL_APPETITE_DELETE: (id) => `${aigBaseUrl}risk-portal/appetite/${id}/delete/`,
        RISK_PORTAL_EVIDENCE_DELETE: (id) => `${aigBaseUrl}risk-portal/evidence/${id}/delete/`,
        RISK_PORTAL_COMMENT_DELETE: (id) => `${aigBaseUrl}risk-portal/comments/${id}/delete/`,
        RISK_PORTAL_PENDING_TREATMENTS: aigBaseUrl + 'risk-portal/treatments/pending/',
        // Workflow Lifecycle
        RISK_PORTAL_WORKFLOW_STATE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/workflow-state/`,
        RISK_PORTAL_ADVANCE_STAGE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/advance-stage/`,
        RISK_PORTAL_ACCEPT_RISK: (id) => `${aigBaseUrl}risk-portal/risks/${id}/accept/`,
        RISK_PORTAL_CLOSE_RISK: (id) => `${aigBaseUrl}risk-portal/risks/${id}/close/`,
        RISK_PORTAL_SEED_DEFAULTS: aigBaseUrl + 'risk-portal/seed-defaults/',
        RISK_PORTAL_BULK_IMPORT: aigBaseUrl + 'risk-portal/bulk-import/',
        RISK_PORTAL_BULK_TEMPLATE: aigBaseUrl + 'risk-portal/bulk-template/',
        // Phase 3: FAIR Model
        RISK_PORTAL_QUANTIFICATION: (id) => `${aigBaseUrl}risk-portal/risks/${id}/quantification/`,
        RISK_PORTAL_QUANTIFICATION_SAVE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/quantification/save/`,
        RISK_PORTAL_MONTE_CARLO: (id) => `${aigBaseUrl}risk-portal/risks/${id}/monte-carlo/`,
        // Phase 3: Bow-Tie
        RISK_PORTAL_BOWTIE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/bowtie/`,
        RISK_PORTAL_BOWTIE_SAVE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/bowtie/save/`,
        // Phase 3: Scenarios
        RISK_PORTAL_SCENARIOS: aigBaseUrl + 'risk-portal/scenarios/',
        RISK_PORTAL_SCENARIO_CREATE: aigBaseUrl + 'risk-portal/scenarios/create/',
        RISK_PORTAL_SCENARIO_DETAIL: (id) => `${aigBaseUrl}risk-portal/scenarios/${id}/`,
        RISK_PORTAL_SCENARIO_DELETE: (id) => `${aigBaseUrl}risk-portal/scenarios/${id}/delete/`,
        // Phase 4: Review Schedules
        RISK_PORTAL_REVIEW_SCHEDULES: aigBaseUrl + 'risk-portal/review-schedules/',
        RISK_PORTAL_REVIEW_SCHEDULE_CREATE: aigBaseUrl + 'risk-portal/review-schedules/create/',
        RISK_PORTAL_REVIEW_SCHEDULE_DELETE: (id) => `${aigBaseUrl}risk-portal/review-schedules/${id}/delete/`,
        // Phase 4: AI
        RISK_PORTAL_AI_CATEGORIZE: aigBaseUrl + 'risk-portal/ai/auto-categorize/',
        RISK_PORTAL_AI_DUPLICATES: aigBaseUrl + 'risk-portal/ai/detect-duplicates/',
        RISK_PORTAL_AI_RISK_STATEMENT: aigBaseUrl + 'risk-portal/ai/generate-risk-statement/',
        RISK_PORTAL_AI_SUGGEST_TREATMENT: aigBaseUrl + 'risk-portal/ai/suggest-treatment/',
        // Board Report
        RISK_PORTAL_BOARD_REPORT: aigBaseUrl + 'risk-portal/board-report/',
        // Risk Sharing
        RISK_PORTAL_SHARE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/share/`,
        RISK_PORTAL_LIST_SHARES: (id) => `${aigBaseUrl}risk-portal/risks/${id}/shares/`,
        RISK_PORTAL_REVOKE_SHARE: (id) => `${aigBaseUrl}risk-portal/shares/${id}/revoke/`,
        RISK_PORTAL_PUBLIC_VIEW: (token) => `${aigBaseUrl}risk-portal/public/${token}/`,
        RISK_PORTAL_PUBLIC_UPDATE: (token) => `${aigBaseUrl}risk-portal/public/${token}/update/`,
        RISK_PORTAL_PUBLIC_ACKNOWLEDGE: (token) => `${aigBaseUrl}risk-portal/public/${token}/acknowledge/`,
        RISK_PORTAL_REQUEST_ACK: (id) => `${aigBaseUrl}risk-portal/risks/${id}/request-acknowledgement/`,
        RISK_PORTAL_GET_ACK: (id) => `${aigBaseUrl}risk-portal/risks/${id}/acknowledgement/`,

        // Risk Portal — Roles / RBAC
        RISK_PORTAL_ROLES: aigBaseUrl + 'risk-portal/roles/',
        RISK_PORTAL_ROLE_DETAIL: (id) => `${aigBaseUrl}risk-portal/roles/${id}/`,
        RISK_PORTAL_ROLE_RESEND_INVITE: (id) => `${aigBaseUrl}risk-portal/roles/${id}/resend-invite/`,
        RISK_PORTAL_ROLES_AUDIT: aigBaseUrl + 'risk-portal/roles-audit-log/',
        RISK_PORTAL_UPDATE_USER_ROLE: (id) => `${aigBaseUrl}risk-portal/portal/users/${id}/role/`,
        AUDIT_CAPA_ASSIGNABLE_USERS: aigBaseUrl + 'audit/capas/assignable-users/',
        AUDIT_CAPA_FINDINGS: aigBaseUrl + 'audit/capas/findings/',

        // Risk Portal — Business Units
        RISK_PORTAL_BUS: aigBaseUrl + 'risk-portal/business-units/',
        RISK_PORTAL_BU_TREE: aigBaseUrl + 'risk-portal/business-units/tree/',
        RISK_PORTAL_BU_DETAIL: (id) => `${aigBaseUrl}risk-portal/business-units/${id}/`,
        RISK_PORTAL_BU_BREAKDOWN: aigBaseUrl + 'risk-portal/bu-risk-breakdown/',

        // Risk Portal — Projects
        RISK_PORTAL_PROJECTS: aigBaseUrl + 'risk-portal/projects/',
        RISK_PORTAL_PROJECT_DETAIL: (id) => `${aigBaseUrl}risk-portal/projects/${id}/`,
        RISK_PORTAL_PROJECT_BREAKDOWN: aigBaseUrl + 'risk-portal/project-risk-breakdown/',

        // Risk Portal — Org Settings / Customisation
        RISK_PORTAL_SETTINGS: aigBaseUrl + 'risk-portal/settings/',
        RISK_PORTAL_SETTINGS_UPDATE: aigBaseUrl + 'risk-portal/settings/update/',
        RISK_PORTAL_PORTFOLIO_TREND: aigBaseUrl + 'risk-portal/portfolio-trend/',

        // Risk Portal — Audit / SLA
        RISK_PORTAL_FIELD_CHANGES: (id) => `${aigBaseUrl}risk-portal/risks/${id}/field-changes/`,
        RISK_PORTAL_SLA_ESCALATIONS: aigBaseUrl + 'risk-portal/sla-escalations/',

        // Risk Portal — Compliance Coverage
        RISK_PORTAL_COMPLIANCE: (id) => `${aigBaseUrl}risk-portal/risks/${id}/compliance/`,
        RISK_PORTAL_COMPLIANCE_MAP: (id) => `${aigBaseUrl}risk-portal/risks/${id}/compliance/map/`,
        RISK_PORTAL_COMPLIANCE_DELETE: (riskId, mapId) => `${aigBaseUrl}risk-portal/risks/${riskId}/compliance/${mapId}/delete/`,
        RISK_PORTAL_COMPLIANCE_COVERAGE: aigBaseUrl + 'risk-portal/compliance-coverage/',

        // Brand Protection — complete route set
        BRAND_PROTECTION_MENTIONS:              baseUrl + 'scanner/brand-protection/mentions/',
        BRAND_PROTECTION_CHART:                 baseUrl + 'scanner/brand-protection/chart/',
        BRAND_PROTECTION_SENTIMENT:             baseUrl + 'scanner/brand-protection/sentiment-summary/',
        BRAND_PROTECTION_INFLUENCERS:           baseUrl + 'scanner/brand-protection/influencers/',
        BRAND_PROTECTION_SOURCES:               baseUrl + 'scanner/brand-protection/sources/',
        BRAND_PROTECTION_UNDISCOVERED:          baseUrl + 'scanner/brand-protection/undiscovered-sources/',
        BRAND_PROTECTION_AVATAR:                baseUrl + 'scanner/brand-protection/avatar/',
        BRAND_PROTECTION_FILTERS:               baseUrl + 'scanner/brand-protection/filters/',
        BRAND_PROTECTION_TOPICS:                baseUrl + 'scanner/brand-protection/topics/',
        BRAND_PROTECTION_ASSISTANT_ASK:         baseUrl + 'scanner/brand-protection/assistant/ask/',
        BRAND_PROTECTION_AI_REVIEW:             baseUrl + 'scanner/brand-protection/assistant/ai-review/',
        BRAND_PROTECTION_AI_COMPARE:            baseUrl + 'scanner/brand-protection/assistant/ai-compare/',
        BRAND_PROTECTION_DEMOGRAPHICS:          baseUrl + 'scanner/brand-protection/demographics/',
        BRAND_PROTECTION_ESCALATION:            baseUrl + 'scanner/brand-protection/escalation-trends/',
        BRAND_PROTECTION_ALERT_LATENCY:         baseUrl + 'scanner/brand-protection/alert-latency/',
        BRAND_PROTECTION_STIX:                  baseUrl + 'scanner/brand-protection/export/stix/',
        BRAND_PROTECTION_CORRELATION:           baseUrl + 'scanner/brand-protection/correlation/',
        BRAND_PROTECTION_REPORT:                (fmt) => baseUrl + `scanner/brand-protection/report/${fmt}/`,
        BRAND_PROTECTION_PHYSICAL_THREATS:      baseUrl + 'scanner/brand-protection/physical-threats/',
        BRAND_PROTECTION_VACCINE_INITIATIVES:   baseUrl + 'scanner/brand-protection/vaccine-initiatives/',
        BRAND_PROTECTION_VACCINE_SAFETY_MISINFO: baseUrl + 'scanner/brand-protection/vaccine-safety-misinfo/',
        BRAND_PROTECTION_VISIT:                 (id) => baseUrl + `scanner/brand-protection/mentions/${id}/visit/`,
        BRAND_PROTECTION_MENTION_VERDICT:       (id) => baseUrl + `scanner/brand-protection/mentions/${id}/verdict/`,
        BRAND_PROTECTION_MUTED_DOMAINS:         baseUrl + 'scanner/brand-protection/muted-domains/',
        BRAND_PROTECTION_UNMUTE_DOMAIN:         (id) => baseUrl + `scanner/brand-protection/muted-domains/${id}/`,
        BRAND_PROTECTION_MENTION_TAGS:          baseUrl + 'scanner/brand-protection/mention-tags/',
        BRAND_PROTECTION_MENTION_TAG_DELETE:    (id) => baseUrl + `scanner/brand-protection/mention-tags/${id}/`,
        BRAND_PROTECTION_MENTION_TAG_APPLY:     (id) => baseUrl + `scanner/brand-protection/mentions/${id}/tag/`,
        BRAND_PROTECTION_REPORT_QUEUE:          baseUrl + 'scanner/brand-protection/report-queue/',
        BRAND_PROTECTION_REPORT_QUEUE_CLEAR:    baseUrl + 'scanner/brand-protection/report-queue/clear/',
        BRAND_PROTECTION_MENTION_QUEUE:         (id) => baseUrl + `scanner/brand-protection/mentions/${id}/queue/`,
        BRAND_PROTECTION_MENTION_TAKEDOWN:      (id) => baseUrl + `scanner/brand-protection/mentions/${id}/request-takedown/`,
        BRAND_PROTECTION_WATCHLISTS:            baseUrl + 'scanner/brand-protection/watchlists/',
        BRAND_PROTECTION_WATCHLISTS_AUDIT:      baseUrl + 'scanner/brand-protection/watchlists/audit-log/',
        BRAND_PROTECTION_WATCHLIST_ENTRIES:     baseUrl + 'scanner/brand-protection/watchlist-entries/',
        BRAND_PROTECTION_WATCHLIST_ENTRY:       (id) => baseUrl + `scanner/brand-protection/watchlist-entries/${id}/`,
        BRAND_PROTECTION_RESCAN_MENTIONS:       baseUrl + 'scanner/brand-protection/rescan-mentions/',
        BRAND_PROTECTION_SCAN_STATUS:           baseUrl + 'scanner/brand-protection/scan-status/',
        BRAND_PROTECTION_MENTIONS_SINCE:        baseUrl + 'scanner/brand-protection/mentions-since/',
        BRAND_PROTECTION_ANCHOR_PREVIEW:        baseUrl + 'scanner/brand-protection/anchor-preview/',
        BRAND_PROTECTION_BOOLEAN_QUERY:         baseUrl + 'scanner/brand-protection/boolean-query/',
        BRAND_PROTECTION_SCAN_CADENCE:          baseUrl + 'scanner/brand-protection/scan-cadence/',
        BRAND_PROTECTION_SERPAPI_USAGE:         baseUrl + 'scanner/brand-protection/serpapi-usage/',
        BRAND_PROTECTION_PAGING_CONFIG:         baseUrl + 'scanner/brand-protection/paging-config/',
        BRAND_PROTECTION_PAGING_TEST:           baseUrl + 'scanner/brand-protection/paging-config/test/',
        BRAND_PROTECTION_LOGO_REGISTRY:         baseUrl + 'scanner/brand-protection/logo-registry/',

        // Admin — integration management (NMT ops surface)
        ADMIN_INTEGRATION_PROVIDERS:            baseUrl + 'admin/integration-providers/',
        ADMIN_VENDOR_CREDS:                     baseUrl + 'admin/vendor-credentials/',
        ADMIN_VENDOR_CREDS_DETAIL:              (id) => baseUrl + `admin/vendor-credentials/${id}/`,
        ADMIN_VENDOR_CREDS_TEST:                (id) => baseUrl + `admin/vendor-credentials/${id}/test/`,
        ADMIN_TENANT_ENTITLEMENTS:              baseUrl + 'admin/tenant-entitlements/',
        ADMIN_TENANT_ENTITLEMENT_DETAIL:        (id) => baseUrl + `admin/tenant-entitlements/${id}/`,
        ADMIN_ORGANIZATIONS:                    baseUrl + 'admin/organizations/',

        // Risk Portal — Ensure Admin (auto-assigns risk_admin role if user has no portal role)
        RISK_PORTAL_ENSURE_ADMIN: aigBaseUrl + 'risk-portal/portal/ensure-admin/',
        CORRELATED_SIGNALS: (params = {}) => {
            const qs = new URLSearchParams(
                Object.entries(params).filter(([_, v]) => v !== null && v !== undefined && v !== '')
            ).toString();
            const base = `${baseUrl}scanner/brand-mentions/load_correlated_signals/`;
            return qs ? `${base}?${qs}` : base;
        },
        // easm APIs
        CREATE_TAKEDOWN_FROM_FINDING: (findingId) =>
            `${aigBaseUrl}scanner/brand-risk-ops/create_takedown_request_from_finding/${findingId}/`,
        TAKEDOWNS_LIST: (params = {}) => {
            const qs = new URLSearchParams(
                Object.entries(params).filter(([_, v]) => v !== null && v !== undefined && v !== '')
            ).toString();
            const base = `${aigBaseUrl}scanner/brand-risk-operations/load_takedowns_list/`;
            return qs ? `${base}?${qs}` : base;
        },
        TAKEDOWN_SLA_METRICS: (params = {}) => {
            const qs = new URLSearchParams(
                Object.entries(params).filter(([_, v]) => v !== null && v !== undefined && v !== '')
            ).toString();
            const base = `${aigBaseUrl}scanner/brand-risk-operations/load_takedown_sla_metrics/`;
            return qs ? `${base}?${qs}` : base;
        },

        BRAND_WATCHLIST: ({ entry_type, is_active } = {}) => {
            let url = `${aigBaseUrl}scanner/brand-watchlist/`;
            const params = new URLSearchParams();
            if (entry_type) params.append('entry_type', entry_type);
            if (is_active !== undefined && is_active !== null) params.append('is_active', is_active);
            const qs = params.toString();
            return qs ? `${url}?${qs}` : url;
        },
        AI_GENERATE_BRAND_WATCHLIST_DEFAULTS: aigBaseUrl + 'scanner/brand-risk-classifier/ai_generate_brand_watchlist_defaults/',
        BRAND_WATCHLIST_CREATE: aigBaseUrl + 'scanner/brand-watchlist/',
        BRAND_WATCHLIST_UPDATE: (id) => `${aigBaseUrl}scanner/brand-watchlist/${id}/`,
        BRAND_WATCHLIST_DELETE: (id) => `${aigBaseUrl}scanner/brand-watchlist/${id}/`,
        BRAND_WATCHLIST_BULK: aigBaseUrl + 'scanner/brand-watchlist/bulk_upsert_brand_watchlist/',


        // Cloud Accounts API
        CLOUD_ACCOUNTS: (process.env.REACT_APP_CLOUD_ACCOUNTS_API_URL || 'http://35.154.239.163:8000/api/') + 'cloud/accounts/',
        CLOUD_ORG_SCORE: (process.env.REACT_APP_CLOUD_ACCOUNTS_API_URL || 'http://35.154.239.163:8000/api/') + 'cloud/org-score/',
        CLOUD_ACCOUNTS_OVERVIEW: (process.env.REACT_APP_CLOUD_ACCOUNTS_API_URL || 'http://35.154.239.163:8000/api/') + 'cloud/accounts/overview/',
        EDIT_CLOUD_ACCOUNT: (accountId) => (process.env.REACT_APP_CLOUD_ACCOUNTS_API_URL || 'http://35.154.239.163:8000/api/') + `cloud/accounts/${accountId}/edit/`,
        RESCAN_CLOUD_ACCOUNT: (accountId) => (process.env.REACT_APP_CLOUD_ACCOUNTS_API_URL || 'http://35.154.239.163:8000/api/') + `cloud/accounts/${accountId}/scan/`,
        CLOUD_SERVICE_DETAILS: (controlId) => (process.env.REACT_APP_CLOUD_ACCOUNTS_API_URL || 'http://35.154.239.163:8000/api/') + `cloud/service-details/${controlId}/`,
    }
})();